import {
  CalendarFiltersActionTypes,
  CalendarFiltersActionUnion
} from './actions';
import { CalendarFiltersState } from './state';
import { ServiceFilters } from '../../helpers/filters/service-filters.helper';

export const initialCalendarFilterState: CalendarFiltersState = {};

export function calendarFiltersReducer(
  state: CalendarFiltersState = initialCalendarFilterState,
  action: CalendarFiltersActionUnion
): CalendarFiltersState {
  let newState;
  switch (action.type) {
    case CalendarFiltersActionTypes.Set:
      newState = {
        ...state,
        [action.payload.name]: action.payload.value
      };
      if (!action.payload.value) {
        delete newState[action.payload.name];
      }
      break;
    case CalendarFiltersActionTypes.SetMany:
      newState = { ...state };
      for (const filterChange of action.payload) {
        if (!filterChange.value) {
          delete newState[filterChange.name];
        } else {
          newState[filterChange.name] = filterChange.value;
        }
      }
      break;
    case CalendarFiltersActionTypes.Reset:
      // eslint-disable-next-line no-case-declarations
      const serviceFilters = ServiceFilters.getServiceFiltersState(state);
      newState = { ...initialCalendarFilterState, ...serviceFilters };
      break;
    case CalendarFiltersActionTypes.SetAll:
      newState = ServiceFilters.applyServiceFilters(state, action.payload);
      break;
    default:
      newState = state;
  }
  return newState;
}
